function initBeforeAfterSliders() {
  const sliders = document.querySelectorAll('.qube-ba-slider');
  
  sliders.forEach(slider => {
    if (slider.dataset.initialized) return;
    slider.dataset.initialized = "true";

    const input = slider.querySelector('.qube-ba-slider__input');
    
    if (input) {
      let isInteracting = false;
      let animationFrame;
      let direction = 1; // 1 for increasing, -1 for decreasing
      
      const duration = parseFloat(slider.dataset.duration) || 3;
      // We want to complete a full 0 to 100 sweep in 'duration' seconds. 
      // Assuming 60fps, total frames = duration * 60. 
      let speed = 100 / (duration * 60); 
      let currentValue = parseFloat(input.value) || 50;

      const animateSlide = () => {
        // Stop the animation loop if the element was removed from the DOM (e.g. Theme Editor reload)
        if (!slider.isConnected) return; 

        if (!isInteracting) {
          currentValue += speed * direction;
          
          if (currentValue >= 100) {
            currentValue = 100;
            direction = -1; // Reverse direction
          } else if (currentValue <= 0) {
            currentValue = 0;
            direction = 1; // Reverse direction
          }
          
          input.value = currentValue;
          slider.style.setProperty('--position', `${currentValue}%`);
        } else {
          // If the user is interacting, keep internal state synced with their dragging
          currentValue = parseFloat(input.value);
        }
        animationFrame = requestAnimationFrame(animateSlide);
      };

      // Start the auto animation
      animationFrame = requestAnimationFrame(animateSlide);

      // Handle manual interaction
      let interactionTimeout;
      
      const handleInteract = (e) => {
        isInteracting = true;
        slider.style.setProperty('--position', `${e.target.value}%`);
        
        // Resume auto-sliding after 3 seconds of inactivity
        clearTimeout(interactionTimeout);
        interactionTimeout = setTimeout(() => {
          isInteracting = false;
          // Set direction based on current position to continue smoothly
          direction = input.value > 50 ? -1 : 1; 
        }, 3000);
      };

      input.addEventListener('input', handleInteract);
      
      // Pause completely while the user is holding down on the slider
      input.addEventListener('touchstart', () => {
        isInteracting = true;
        clearTimeout(interactionTimeout);
      }, { passive: true });
      
      input.addEventListener('mousedown', () => {
        isInteracting = true;
        clearTimeout(interactionTimeout);
      });
    }
  });
}

document.addEventListener('DOMContentLoaded', initBeforeAfterSliders);
document.addEventListener('shopify:section:load', initBeforeAfterSliders);
